<template>
  <div class="information-list" :style="scale">
    <InformationCard v-for="(item, index) in informationData" :key="index" :card-data="item" :search-name="searchName"/>
  </div>
</template>

<script>
import InformationCard from "../InformationCard/index.vue"
export default {
  props: {
    informationData: {
      type: Array,
      default: () => [],
    },
    scale: {
      type: Object,
      default: () => ({
        width: "100%",
        height: "100%",
      }),
    },
    searchName:{
      type: String,
      default: () => ""
    }
  },
  components: {
    InformationCard,
  },
}
</script>

<style>
.information-list {
  overflow: auto;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
  padding: 0 10px;
  border-radius: 10px;
  box-sizing: border-box;
  height: 90%;
  overflow: auto;
}
</style>
